/** * @description: 头部 * @author: fire * @update: hwx */
<template>
	<div>
		<div class="header">
			<div class="user-wrapper">
				<div class="navbar-wrapper">
					<router-link tag="div" to="/" class="logo">
						<img src="../assets/images/logo.png" class="logo-img" />
						<div class="logo-text">
							<h1>智慧商家桌面版</h1>
							<p>技术支持方：厦门巨嗨科技有限公司</p>
						</div>
					</router-link>
					<div class="menu-list" v-if="isShowMenuList">
						<v-menu></v-menu>
					</div>
				</div>
				<div class="header-right">
					<div class="account-AI" v-on:click="openAI" v-if="$store.state.aiModule.status == 1">
						<img :src="$store.state.aiModule.icon" alt="" class="icon-user-head50x30">
						<div class="mobile-text">{{ $store.state.aiModule.name || 'AI人工智能' }}</div>
						<i class="icon-arrow-top14x8" :class="{ open: isOpenAIOption }"></i>
						<div class="user-option" :class="{ 'open-option': isOpenAIOption }">
							<ul>
								<li v-for="(item, index) in $store.state.aiModule.children" :key="index" v-on:click="handleAIMenuClick(item)" v-if="item.status == 1">
									<span>{{ item.name }}</span>
								</li>
							</ul>
						</div>
					</div>
					<div v-if="mobile != ''" class="account-op" v-on:click="open">
						<i class="icon-user-head30x30"></i>
						<div class="mobile-text">{{ mobile }}</div>
						<i class="icon-arrow-top14x8" :class="{ open: isOpenOption }"></i>
						<div class="user-option" :class="{ 'open-option': isOpenOption }">
							<ul>
								<li v-on:click="showMainEdit">
									<i class="icon-edit active"></i>
									<span>修改密码</span>
								</li>
								<li v-on:click="showMainExit">
									<i class="icon-exit"></i>
									<span>退出</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 修改密码弹窗 -->
		<div class="reset-password-layer ele-hide" ref="reset_password_layer">
			<el-form label-width="80px">
				<el-form-item label="原密码">
					<el-input
						type="password"
						placeholder="请输入原密码"
						v-model="old_password"
					></el-input>
				</el-form-item>
				<el-form-item label="新密码">
					<el-input
						type="password"
						placeholder="请输入新密码"
						v-model="new_password_1"
					></el-input>
					<span>不少于6个字符，不区分数字英文，不能使用特殊字符</span>
				</el-form-item>
				<el-form-item label="确认密码">
					<el-input
						type="password"
						placeholder="再次输入新密码"
						v-model="new_password_2"
					></el-input>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
import Vue from "vue";
import * as types from "../store/types";
import menu from "./menu.vue";

export default {
	name: "",
	data() {
		return {
			isOpenOption: false, // 打开选项
			isOpenAIOption: false,
			old_password: "",
			new_password_1: "",
			new_password_2: "",
			editPasswordLayer: "",
		};
	},
	components: {
		"v-menu": menu,
	},
	computed: {
		mobile() {
			return this.$store.state.usermobile;
		},
		isShowMenuList() {
			return this.$store.state.isShowMenuList;
		},
	},
	created: function () {},
	methods: {
		open() {
			this.isOpenOption = !this.isOpenOption;
		},
		openAI() {
			this.isOpenAIOption = !this.isOpenAIOption;
		},
		handleAIMenuClick(item) {
			if (item.type === 2 && item.link) {
				window.location.href = item.link;
			} else if (item.type === 3 && item.type_value) {
				window.location.href = item.type_value;
			}
		},
		// 修改密码
		showMainEdit() {
			const _this = this;

			_this.old_password = "";
			_this.new_password_1 = "";
			_this.new_password_2 = "";
			layer.confirm(
				"",
				{
					skin: "public-alert-skin",
					type: 1,
					btn: ["确定", "取消"], // 按钮
					title: ["修改密码", true],
					area: ["600px", ""], // 宽高
					content: $(_this.$refs.reset_password_layer),
				},
				function () {
					if (_this.new_password_1 != _this.new_password_2) {
						layer.msg("两次输入密码不一致！");
						return false;
					}
					Vue.axios
						.post("User/api_changePasswordByOldPwd", {
							header: Vue.request_header,
							request: {
								version: Vue.version,
								param: {
									old_password: _this.old_password,
									new_password_1: _this.new_password_1,
									new_password_2: _this.new_password_2,
								},
							},
							comment: "",
						})
						.then((res) => {
							if (res.data.response.result_code == "true") {
								layer.closeAll();
								layer.msg("密码修改成功");
							} else {
								Vue.timeoutfun(res.data.response.result_status, _this);
								layer.msg(res.data.response.error_msg);
							}
						})
						.catch((err) => {
							layer.msg("出错啦");
						});
				}
			);
		},
		// 退出登录
		showMainExit() {
			const _this = this;

			Vue.axios
				.post("User/public_logout", {
					header: Vue.request_header,
					request: {
						version: Vue.version,
						param: {},
					},
					comment: "",
				})
				.then((res) => {
					if (res.data.response.result_code == "true") {
						layer.msg("退出成功");
						Vue.request_header.merchant_id = "";
						_this.$store.commit(types.LOGOUT);
						_this.$store.commit(types.AIMODULE, false); // 清除 AI 模块状态
						_this.$router.push({
							path: "/login",
						});
					} else {
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch((err) => {
					layer.msg("出错啦");
				});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.header {
	position: fixed;
	width: 100%;
	left: 0px;
	top: 0px;
	padding-bottom: 10px;
	background: #f5f5f5;
	z-index: 1;
	.user-wrapper {
		display: flex;
		justify-content: space-between;
		height: 62px;
		line-height: 62px;
		padding: 0 15px;
		background: #333;
		.navbar-wrapper {
			display: flex;
			justify-content: space-between;
			.logo {
				display: flex;
				justify-content: space-between;
				margin-right: 50px;
				color: @white;
				cursor: pointer;
				.logo-img {
					width: 50px;
					height: 50px;
					margin: 6px 0;
				}
				.logo-text {
					padding: 10px 0 0 15px;
					h1 {
						margin: 0;
						font-size: 20px;
					}
					p {
						margin: 0;
						line-height: 30px;
						font-size: 14px;
					}
				}
			}
			.menu-list {
				font-size: 16px;
				ul {
					display: flex;
					justify-content: space-between;
					.menu-item {
						padding: 0 15px;
						user-select: none;
						color: @white;
						cursor: pointer;
						&.active {
							color: #009af0;
						}
					}
				}
			}
		}
		.header-right {
			display: flex;
			.account-AI {
				margin-right: 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				user-select: none;
				color: #fff;
				cursor: pointer;
				.icon-user-head50x30 {
					width: 30px;
					height: 30px;
					background-size: cover;
				}
				.icon-arrow-top14x8 {
					width: 14px;
					height: 8px;
					background-image: url("../assets/images/icon-arrow-top14x8.png");
				}
				.open {
					transform: rotate(180deg);
				}
				.mobile-text {
					margin: 0 5px;
				}
				.user-option {
					display: none;
					position: absolute;
					padding-left: 15px;
					padding-right: 15px;
					right: 170px;
					top: 50px;
					border: 1px solid #8ccef2;
					color: #333333;	
					background-color: #fff;
					z-index: 1000;
					&.open-option {
						display: block;
					}
					ul {
						margin-bottom: 0px;
						li {
							display: flex;
							align-items: center;
							justify-content: center;
							height: 34px;
							line-height: 34px;
							&:hover {
								background-color: #eee;
							}
						}
						
					}
				}
			}

			.account-op {
				display: flex;
				justify-content: space-between;
				align-items: center;
				user-select: none;
				color: #fff;
				cursor: pointer;
				.icon-user-head30x30 {
					width: 30px;
					height: 30px;
					background-image: url("../assets/images/user-head30x30.png");
				}
				.icon-arrow-top14x8 {
					width: 14px;
					height: 8px;
					background-image: url("../assets/images/icon-arrow-top14x8.png");
				}
				.open {
					transform: rotate(180deg);
				}
				.mobile-text {
					margin: 0 5px;
				}
				.user-option {
					display: none;
					position: absolute;
					right: 15px;
					top: 50px;
					width: 102px;
					border: 1px solid #8ccef2;
					color: #333333;
					background-color: #fff;
					z-index: 1000;
					&.open-option {
						display: block;
					}
					ul {
						margin-bottom: 0px;
						li {
							display: flex;
							align-items: center;
							height: 34px;
							line-height: 34px;
							&:hover {
								background-color: #eee;
							}
						}
						i {
							width: 13px;
							height: 14px;
							margin: 0 8px;
						}
						.icon-edit {
							background-image: url(../assets/images/login/edit.png);
						}
						.icon-exit {
							background: url(../assets/images/login/exit.png) center center
								no-repeat;
						}
					}
				}
			}
		}
	}
}
.reset-password-layer {
	.el-input {
		width: 260px;
	}
	span {
		display: inline-block;
		vertical-align: bottom;
		width: 170px;
		height: 40px;
		margin-left: 15px;
		line-height: 20px;
		color: #009af0;
	}
}
</style>
